import { BillingFieldKeyType, GenericUIConfigurationType } from '../../@types';
import { EmailControl } from '../ui/controls/EmailControl';
import { CountryControl } from '../ui/controls/CountryControl';
import { DocTypeControl } from '../ui/controls/DocTypeControl';

// TODO: Commented fields are used on MFD, should we add them?
export const BillingFieldMap: GenericUIConfigurationType<BillingFieldKeyType> =
  {
    meta: {
      label: 'billingAddressDetails',
    },
    fields: {
      billingFirstName: {
        name: 'billingFirstName',
        label: 'firstName',
        className: 'ShortTextControl',
      },
      billingLastName: {
        name: 'billingLastName',
        label: 'lastName',
        className: 'ShortTextControl',
      },
      billingName: {
        name: 'billingName',
        label: 'fullName',
      },
      billingBirthday: {
        name: 'billingBirthday',
        label: 'billingBirthday',
        className: 'ShortTextControl',
      },
      billingDocumentNumber: {
        name: 'billingDocumentNumber',
        label: 'billingDocumentNumber',
        className: 'ShortTextControl',
      },
      billingDocumentType: {
        component: DocTypeControl,
        name: 'billingDocumentType',
        label: 'billingDocumentType',
        className: 'ShortTextControl',
      },
      billingTaxId: {
        name: 'billingTaxId',
        label: 'billingTaxId',
        className: 'ShortTextControl',
      },
      billingAddress1: {
        name: 'billingAddress1',
        label: 'billingStreetAddress',
      },
      billingAddress2: {
        name: 'billingAddress2',
        label: 'billingStreetAddress2',
      },
      billingState: {
        name: 'billingState',
        label: 'billingState',
        className: 'ShortTextControl',
      },
      billingCity: {
        name: 'billingCity',
        label: 'billingCity',
        className: 'ShortTextControl',
      },
      billingZip: {
        name: 'billingZip',
        label: 'billingZip',
        className: 'ShortTextControl',
      },
      billingCountry: {
        component: CountryControl,
        name: 'billingCountry',
        label: 'billingCountry',
        // options: {}, // get countries list here
      },
      billingEmail: {
        component: EmailControl,
        name: 'billingEmail',
        label: 'billingEmail',
      },
      billingCompany: {
        name: 'billingCompany',
        label: 'billingCompany',
      },
      billingPhone: {
        name: 'billingPhone',
        label: 'phone',
        className: 'ShortTextControl',
      },
      billingFax: {
        name: 'billingFax',
        label: 'billingFax',
        className: 'ShortTextControl',
      },
    },
  };
